import {
    NEWSMTP,SHOW_LOADING,UPDATESMTP
} from "../constants/SMTPCredentials";
import {
    AUTH_TOKEN, HIDE_AUTH_MESSAGE, SHOW_AUTH_MESSAGE
} from "../constants/Auth";

const initState = {
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    token: localStorage.getItem(AUTH_TOKEN),
}

const SMTP = (state = initState, action) => {
    switch (action.type) {
        case NEWSMTP:
            return {
                ...state,
                loading: false,
                message: action.message,
                showMessage: true,
            }
        case SHOW_AUTH_MESSAGE:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case UPDATESMTP:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false,
            }
        case HIDE_AUTH_MESSAGE:
            return {
                ...state,
                message: '',
                showMessage: false,
            }
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true
            }
        }
        default:
            return state;
    }
}

export default SMTP